// MpfDialog.props.ts

import type { Ref, ComputedRef } from 'vue';

type MpfDialogType = 'dialog' | 'modal';

type MpfMaybeRef<T> = T | Ref<T> | ComputedRef<T>;

type MpfDialogBodyText =
  | { kind: 'text'; value: MpfMaybeRef<string> }
  | { kind: 'html'; value: MpfMaybeRef<string> };

export type MpfDialogOkReason = 'ok';
export type MpfDialogCancelReason = 'cancel' | 'esc' | 'backdrop';

export type MpfDialogProps = {
  modelValue?: boolean;
  type?: MpfDialogType;
  title: MpfMaybeRef<string>;
  straplineText?: MpfMaybeRef<string>;
  bodyText?: MpfDialogBodyText;
  okText?: MpfMaybeRef<string>;
  cancelText?: MpfMaybeRef<string>;
  onOk?: (reason?: MpfDialogOkReason) => void | Promise<void>;
  onCancel?: (reason?: MpfDialogCancelReason) => void | Promise<void>;
  closeOnEsc?: boolean;
  closeDialog?: () => void;
  testId?: string;
  ariaLabel?: string;
  // sr announcing
  announceOnOpen?: boolean;
  announceTargetId?: string;
  announceWhileOpenMs?: number;
};

export const MpfDialogDefaults = {
  modelValue: false,
  type: 'dialog',
  straplineText: undefined,
  okText: 'OK',
  cancelText: 'Cancel',
  onOk: undefined,
  onCancel: undefined,
  closeOnEsc: true,
  closeDialog: undefined,
  testId: undefined,
  ariaLabel: undefined,
  announceOnOpen: true,
  announceTargetId: 'mpf-status',
  announceWhileOpenMs: 30000,
} satisfies Partial<MpfDialogProps>;

export type MpfDialogEmits = {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'opened'): void;
  (e: 'closed'): void;
};
